module.exports = __webpack_public_path__ + "img/kommune-1112.96fbcc35.svg";